import { useSelector } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';
import { theme } from '@utils/libs/theme';
import { SplitButtonCopy, ThemeButtonIcon } from '@shared/ui/buttons';

export default function EmailBtn({
  email,
  text = 'E-mail',
  changeOnMobile = false,
}) {
  const { configs } = useSelector((state) => state.configs);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const address = email || configs.support_email;
  const options = {
    icon: 'email',
    href: `mailto:${address}`,
  };

  return isMobile && changeOnMobile ? (
    <ThemeButtonIcon as="a" {...options} />
  ) : (
    <SplitButtonCopy {...options} value={address} text={text} />
  );
}
